import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import type { NotificationResponse } from '@/types/notification';
import { formatNotificationTime, isNotificationUnread, cleanNotificationText } from '@/utils/notificationUi';

type Props = {
  notification: NotificationResponse;
  compact?: boolean;
  onOpen?: () => void;
};

export function NotificationInboxItem({ notification, compact = false, onOpen }: Props) {
  const unread = isNotificationUnread(notification);
  const title = cleanNotificationText(notification.title);
  const message = cleanNotificationText(notification.message);

  return (
    <button
      type="button"
      className={`flex w-full gap-3 border-b border-slate-100 px-3 py-2.5 text-left transition-colors last:border-b-0 hover:bg-slate-50 dark:border-slate-800 dark:hover:bg-slate-800/80 ${
        unread ? 'bg-primary-50/40 dark:bg-primary-950/20' : 'opacity-90'
      }`}
      onClick={onOpen}
    >
      <span
        className={`mt-1.5 h-2 w-2 shrink-0 rounded-full ${
          unread ? 'bg-primary-500' : 'bg-transparent'
        }`}
        aria-hidden
      />
      <span className="min-w-0 flex-1">
        <span className="flex items-start justify-between gap-2">
          <span className={`text-sm ${unread ? 'font-semibold text-slate-900 dark:text-slate-100' : 'font-medium text-slate-700 dark:text-slate-300'}`}>
            {title}
          </span>
          <span className="shrink-0 text-[10px] text-slate-400">
            {formatNotificationTime(notification.createdAt)}
          </span>
        </span>
        <span
          className={`mt-0.5 block text-slate-500 dark:text-slate-400 ${
            compact ? 'line-clamp-2 text-xs' : 'text-sm'
          }`}
        >
          {message}
        </span>
      </span>
    </button>
  );
}

export function NotificationInboxEmpty({ moduleScoped }: { moduleScoped?: boolean }) {
  return (
    <div className="flex flex-col items-center justify-center px-4 py-8 text-center">
      <NotificationsNoneIcon className="mb-2 text-slate-300 dark:text-slate-600" />
      <p className="text-sm font-medium text-slate-600 dark:text-slate-300">All caught up</p>
      <p className="mt-1 text-xs text-slate-400">
        {moduleScoped ? 'No notifications for this module' : 'No notifications yet'}
      </p>
    </div>
  );
}
